export enum WidgetEvents {
  DESTROY = 'destroy',
  INITIALIZED = 'initialized',
}
